import React from "react";
import LaddaButton, { EXPAND_RIGHT, S } from "react-ladda";
import { Card, CardBlock, FormGroup, Label } from "reactstrap";
//import {Table, Th, Thead} from 'reactable';
// import IconDot from 'react-icons/lib/md/fiber-manual-record';
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { browserHistory } from "react-router";
import FacilityListClass from "../../shared/components/facility_list";
import StateListClass from "../../shared/components/state_list";
import ReportTableClass from "./report_table";

// import { extendMoment } from 'moment-range';

import AlertMessageClass from "../../shared/components/alert_message";
import LoaderClass from "../../shared/components/loader";
// import DatePicker1 from 'react-date-picker';

// import DatePicker3 from 'react-date-picker/build/entry.nostyle';

import { getRequest, postRequest } from "../../utils/apiUtils";
import Utils from "../../utils/utils";
import "./style.css";

var axios = require("axios");
var simpleReactValidator = require("simple-react-validator");
// var dateFormat = require('dateformat');
// var now = new Date();
// const moment1 = extendMoment(moment);

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new simpleReactValidator();
    this.state = {
      report_list: [],
      state_list: [],
      fac_list: [],
      drpStateValue: "",
      drpFacValue: "",
      fromValue: "",
      toValue: "",
      fromDate: moment().subtract(30, "days"),
      toDate: moment(),
      loading: false,
      alertMessageText: "",
      alertMessageVisible: false,
      alertMessageColor: "",
      date: new Date(),
      loaderStatus: true,
    };
    this.drpChangeState = this.drpChangeState.bind(this);

    this.drpChangeFac = this.drpChangeFac.bind(this);

    this.fromDateChange = this.fromDateChange.bind(this);
    this.toDateChange = this.toDateChange.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
  }

  drpChangeState = (e) => {
    var that = this;
    const state_id = e.target.value;
    //console.log(state_id);
    if (state_id !== "") {
      that.setState({ drpStateValue: state_id, fac_list: [], drdFacValue: "" });
      getRequest({ url: "/api/get_fac_list_by_state_id/" + state_id })
        .then(function (response) {
          that.setState({ fac_list: Array.isArray(response.data.result) ? response.data.result : [] });
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 403) {
              browserHistory.push("/");
              window.location.reload();
            } else {
              console.log(error);
            }
          } else {
            console.log(error);
          }
        });
    } else {
      that.setState({
        fac_list: [],
        drpStateValue: "",
        alertMessageVisible: false,
      });
    }
  };

  onDismiss() {
    var that = this;
    that.setState({
      alertMessageVisible: false,
    });
  }

  btnSearch = (e) => {
    var that = this;
    if (that.validator.allValid()) {
    } else {
      that.validator.showMessages();
      // rerender to show messages for the first time
      that.forceUpdate();
    }
    var state_id = that.state.drpStateValue;
    //console.log(state_id);
    var facility_id = that.state.drpFacValue;
    //console.log(facility_id);
    var getdate = that.state.toDate;
    var to_date = moment(getdate).format("YYYY-MM-DD"); //"2017-09-23"; //that.state.toDate;
    //console.log(to_date);
    var getdateForm = that.state.fromDate;
    var from_date = moment(getdateForm).format("YYYY-MM-DD"); //"2017-08-09";
    // console.log(from_date);

    if (state_id !== "" && facility_id !== undefined && facility_id !== "" && to_date !== "" && from_date !== "") {
      that.setState({
        loading: !this.state.loading,
        progress: 0.5,
        loaderStatus: true,
      });
      postRequest(
        {
          url: "/api/audit_facility_filter/",
          payload: {
            facility_id: facility_id,
            to_date: to_date,
            from_date: from_date,
          },
        },
        { headers: Utils.getRequiredHeaders() }
      )
        .then(function (response) {
          //console.log(response.data.result);
          if (response.data.success) {
            that.setState({
              alertMessageVisible: false,
              report_list: response.data.result,
              loaderStatus: true,
            });
          } else {
            that.setState({
              alertMessageVisible: true,
              alertMessageColor: "danger",
              alertMessageText: response.data.message,
              report_list: [],
              loaderStatus: true,
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 403) {
              browserHistory.push("/");
              window.location.reload();
            } else {
              console.log(error);
            }
          } else {
            console.log(error);
          }
          //console.log(error);
        });
      that.setState({ loading: false });
    }
  };

  drpChangeFac = (e) => {
    var fac_id = e.target.value;
    if (fac_id !== null) {
      this.setState({ drpFacValue: e.target.value });
    } else {
      this.setState({ drpFacValue: "" });
    }
  };
  fromDateChange(date) {
    this.setState({ fromDate: date });
  }
  toDateChange(date) {
    //console.log(date);
    this.setState({ toDate: date });
  }

  preSignedUrl = (url) => {
    var that = this;
    postRequest(
      {
        url: "/api/get_presigned_url",
        payload: {
          url: url,
        },
      },
      { headers: Utils.getRequiredHeaders() }
    ).then(function (response) {
      if (response.data.success) {
        window.open(response.data.result, "_blank");
      } else {
        that.setState({
          alertMessageVisible: true,
          alertMessageColor: "danger",
          alertMessageText: response.data.message,
        });
      }
    });
  };

  componentDidMount() {
    var that = this;
    getRequest({ url: "/api/get_all_statelist" })
      .then(function (state_response) {
        //console.log(state_response.status);
        that.setState({ state_list: state_response.data.result });
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 403) {
            browserHistory.push("/");
            window.location.reload();
          } else {
            console.log(error);
          }
        } else {
          console.log(error);
        }
      });

    getRequest({ url: "api/get_user_data" })
      .then(function (response) {
        if (response.data != "") {
          var db_state_id = response.data[0]["state_id"];
          that.setState({
            drpStateValue: db_state_id,
          });

          getRequest({ url: "/api/get_fac_list_by_state_id/" + db_state_id })
            .then(function (response) {
              that.setState({ fac_list: Array.isArray(response.data.result) ? response.data.result : [] });
            })
            .catch(function (error) {
              if (error.response) {
                if (error.response.status === 403) {
                  browserHistory.push("/");
                  window.location.reload();
                } else {
                  console.log(error);
                }
              } else {
                console.log(error);
              }
            });

          if (response.data[0]["facilities"].length > 0 && response.data[0]["facilities"].length > 0) {
            var db_state_id = response.data[0]["state_id"];
            var db_facility_id = response.data[0]["facilities"][0]["facility_id"];
            //dispatch(fetchFacilityList(db_state_id));
            //that.bindFac();
            that.setState({
              drdFacValue: db_facility_id,
            });
            //console.log("db_state_id: "+db_facility_id)
          }
        }
        //console.log("res: "+response.data[0]['facilities']);
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 403) {
          } else {
            console.log(error);
          }
        } else {
          console.log(error);
        }
      });
  }

  render() {
    const ViewHeader = () => (
      <div className="page-header">
        <h1 className="title">Reports</h1>
        <p className="subtitle">View and export audit and rectification reports here</p>
      </div>
    );

    const ViewContent = ({ children }) => <div className="view-content view-components">{children}</div>;

    const BindFacList = () => <FacilityListClass facilityFillData={this.state.fac_list} facilityValue={this.state.drpFacValue} drpChangeFac={this.drpChangeFac} />;

    const AlertMessage = () => (
      <AlertMessageClass
        alertMessageColor={this.state.alertMessageColor}
        alertMessageVisible={this.state.alertMessageVisible}
        onDismiss={this.onDismiss}
        alertMessageText={this.state.alertMessageText}
      />
    );

    const BindStateList = () => <StateListClass stateValue={this.state.drpStateValue} drpChangeState={this.drpChangeState} stateFillData={this.state.state_list} />;

    const reportNewData = this.state.report_list;
    var mytestArry = new Array();
    var full_report_link1 = "";
    var graph_report_link1 = "";
    var rectification_report_link1 = "";
    for (var j = 0; j < reportNewData.length; j++) {
      var getdata = JSON.parse(reportNewData[j]["report_path"]) || [];
      mytestArry = reportNewData;

      getdata.forEach(function (itemi) {
        if (itemi["full_report_link"] != null) {
          full_report_link1 = itemi["full_report_link"];
        }
        if (itemi["graph_report_link"] != null) {
          graph_report_link1 = itemi["graph_report_link"];
        }
        if (itemi["rectification_report_link"] != null) {
          rectification_report_link1 = itemi["rectification_report_link"];
        }
      });
      mytestArry[j]["full_report_link"] = full_report_link1;
      mytestArry[j]["graph_report_link"] = graph_report_link1;
      mytestArry[j]["rectification_report_link"] = rectification_report_link1;
    }

    //console.log(TestData);
    const FilterBox = ({ children }) => (
      <div className="row">
        <div className="col-12 col-md-6">
          <FormGroup>
            <Label>From</Label>
            <DatePicker
              className="form-control"
              selected={this.state.fromDate}
              selectsStart
              withPortal
              maxDate={this.state.toDate}
              dateFormat="DD-MM-YYYY"
              startDate={this.state.fromDate}
              endDate={this.state.toDate}
              onChange={this.fromDateChange}
            />
            <span className="error-text">{this.validator.message("from date", this.state.fromDate, "required")}</span>
          </FormGroup>
          <FormGroup>
            <Label>State</Label>
            <BindStateList />
            <span className="error-text">{this.validator.message("state", this.state.drpStateValue, "required")}</span>
          </FormGroup>
        </div>
        <div className="col-12 col-md-6">
          <FormGroup>
            <Label>To</Label>
            <DatePicker
              className="form-control"
              selected={this.state.toDate}
              selectsEnd
              withPortal
              minDate={this.state.fromDate}
              dateFormat="DD-MM-YYYY"
              startDate={this.state.fromDate}
              endDate={this.state.toDate}
              onChange={this.toDateChange}
            />
            <span className="error-text">{this.validator.message("to date", this.state.toDate, "required")}</span>
          </FormGroup>

          <FormGroup>
            <Label>Facility Name</Label>
            <BindFacList />
            <span className="error-text">{this.validator.message("facility", this.state.drpFacValue, "required")}</span>
          </FormGroup>
        </div>
        <div className="col-12 col-md-12">
          <FormGroup>
            <LaddaButton
              className="btn btn-warning btn-search"
              loading={this.state.loading}
              onClick={this.btnSearch}
              data-color="#eee"
              data-size={S}
              data-style={EXPAND_RIGHT}
              data-spinner-size={30}
              data-spinner-color="#ddd"
              data-spinner-lines={12}
            >
              <i className="fa fa-search"></i> Search
            </LaddaButton>
          </FormGroup>
        </div>
        {/* <div className="col-12 col-md-3">
              
                </div>

                <div className="col-12 col-md-12">
                   
                </div> */}
      </div>
    );

    const ReportTable = () => <ReportTableClass reportFillData={reportNewData} preSignedUrl={this.preSignedUrl} />;
    return (
      <div className="view">
        <ViewHeader />
        <ViewContent>
          <Card className="mb-4 comp-minHeight">
            <CardBlock className="table-responsive">
              <h6 className="mb-4 text-uppercase">Search</h6>
              <FilterBox />
            </CardBlock>
          </Card>
          <Card className="mb-4">
            <CardBlock className="table-responsive">
              <h6 className="mb-4 text-uppercase">Audit Report History</h6>
              <AlertMessage />
              <ReportTable />
              <LoaderClass visibleStatus={this.state.loaderStatus} />
            </CardBlock>
          </Card>
        </ViewContent>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/reports/index.js